import { styled } from "@mui/material";

export const WorkflowWrapper = styled("div")({
  display: "flex",
  alignItems: "center",
  gap: "8px",
  marginTop: "10px",
  position: "relative",
});

export const WorkflowItem = styled("div")({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  position: "relative",
  width: "40px",
});

export const WorkflowItemConnector = styled("div")({
  width: "clamp(30px, 8vw, 70px)",
  height: "2px",
  background: "#EB0A1E",
  marginTop: "-9px",
});

export const WorkflowItemTop = styled("div")({
  minHeight: "14px",
  fontSize: "10px",
  fontWeight: "600",
  color: "#7F7E7E",
  width: "100px",
  textAlign: "center",
});

export const WorkflowItemDown = styled("div")({
  height: "28px",
  fontSize: "12px",
  fontWeight: "600",
  color: "#424242",
  marginTop: "5px",
  width: "98px",
  textAlign: "center",
});

export const WorkflowItemIconWrapper = styled("div")({
  marginTop: "10px",
  width: "40px",
  height: "40px",
  borderRadius: "50%",
  border: "2px solid red",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
});

export const WorkflowItemIcon = styled("img")({
  width: "18px",
});
